import * as ReportColors from 'shells/colors/reports';

import {
    OTHER_BUCKET_NAME,
    NONE_BUCKET_NAME,
    SEGMENT_STATUS,
    SEGMENT_LEAD_STATUS,
    SEGMENT_SUBSCRIPTION_STATUS,
} from '../report-constants';
import type {ReportKey} from '../report-types';

export function getSegmentColor(
    segment: string,
    name: string,
    numberOfSegments: number,
    index: number,
    reportKey: ReportKey
) {
    if (reportKey === 'tasks') {
        // @ts-expect-error
        return ReportColors.TaskColors[name];
    } else if (reportKey === 'quotes') {
        // @ts-expect-error
        return ReportColors.QuoteStatusColors[name];
    } else if (reportKey === 'invoices') {
        // @ts-expect-error
        return ReportColors.InvoiceStatusColors[name];
    } else if (reportKey === 'completedActions') {
        // @ts-expect-error
        return ReportColors.CompletedActionsColors[name];
    }

    if (name === OTHER_BUCKET_NAME) {
        return ReportColors.OTHER;
    } else if (name === NONE_BUCKET_NAME) {
        return ReportColors.NONE;
    } else if (segment === SEGMENT_STATUS.id) {
        // @ts-expect-error
        return ReportColors.StatusColors[name];
    } else if (segment === SEGMENT_LEAD_STATUS.id) {
        // @ts-expect-error
        return ReportColors.OutcomeColors[name];
    } else if (segment === SEGMENT_SUBSCRIPTION_STATUS.id) {
        // @ts-expect-error
        return ReportColors.SubscriptionStatusColors[name];
    } else {
        // @ts-expect-error
        return ReportColors.SegmentColors[numberOfSegments - 1][index];
    }
}
